import Box from "@mui/material/Box";
import * as Sentry from "@sentry/react";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../AuthProvider.tsx";
import { startSsoRegistration } from "../lib/auth-client";
import { BaseSkeleton } from "../lib/closet.tsx";

const oryOrigin = import.meta.env.VITE_KRATOS_API_ORIGIN;

// Kratos's Google provider only accepts ameelio.org Workspace accounts and
// maps them to the ameeliostaff identity schema.
const AMEELIO_STAFF_IDP = "google";

// Launch Ameelio staff Google sign-in directly, skipping the Kratos login UI.
export default function AmeelioLoginPage() {
  const navigate = useNavigate();
  const attempted = useRef(false);
  const { orySession } = useAuthContext();

  // Start the staff provider's Kratos registration flow and handle its redirect.
  useEffect(() => {
    if (attempted.current || !oryOrigin) return;

    // Kratos can reject/redirect a *registration* flow while a session is
    // already active - go straight into the toolbox instead of starting a new
    // flow.
    if (orySession?.active) {
      void navigate("/toolbox", { replace: true });
      return;
    }

    attempted.current = true;

    const returnTo = `${window.location.origin}/toolbox`;

    void (async () => {
      try {
        window.location.href = await startSsoRegistration({
          oryOrigin,
          provider: AMEELIO_STAFF_IDP,
          returnTo,
        });
      } catch (err) {
        Sentry.captureException(err);
        // Fall back to the Kratos login UI, which still offers Google sign-in.
        window.location.href = `${oryOrigin}/self-service/login/browser?return_to=${returnTo}`;
      }
    })();
  }, [navigate, orySession?.active]);

  return (
    <Box style={{ height: "100vh" }}>
      <BaseSkeleton />
    </Box>
  );
}
